<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="12">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Manutenção</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Manutenção da Termometria</h1>
      </el-col>
    </el-row>


    <br/>
    
    <el-row :gutter="10">

      <el-col :span="12">
        <el-card class="box-card">
          <div class="text-2 item-2">
            <h3>Clientes</h3>
            <el-form :model="mudar_vendedor_cliente" ref="formMudarVendedorCliente" @submit.native.prevent="mudarVendedorCliente">


              <el-form-item label="Vendedor Atual" prop="vendedor_atual_id" :rules="{ required: true, message: 'Selecione o Vendedor atual', trigger: 'change' }">
                <br />
                <el-select 
                  v-model="mudar_vendedor_cliente.vendedor_atual_id" 
                  filterable 
                  placeholder="Selecione um vendedor atual" 
                  clearable 
                  class="select-data-2"
                >
                  <el-option v-for="vendedor in vendedores" :key="vendedor.id" :label="vendedor.nome" :value="vendedor.id" />
                </el-select>
              </el-form-item>


              <el-form-item label="Vendedor Novo" prop="vendedor_novo_id" :rules="{ required: true, message: 'Selecione um Vendedor novo', trigger: 'change' }">
                <br />
                <el-select 
                  v-model="mudar_vendedor_cliente.vendedor_novo_id" 
                  filterable 
                  placeholder="Selecione o vendedor novo" 
                  clearable 
                  class="select-data-2"
                >
                  <el-option v-for="vendedor in vendedores" :key="vendedor.id" :label="vendedor.nome" :value="vendedor.id" />
                </el-select>
              </el-form-item>


              <el-button type="primary" native-type="submit">Alterar Vendedor dos Clientes</el-button>
            </el-form>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="text-2 item-2">

            <h3>Orçamentos</h3>
            <el-form :model="mudar_vendedor_orcamento" ref="formMudarVendedorOrcamento" @submit.native.prevent="mudarVendedorOrcamento">


              <el-form-item label="Vendedor Atual" prop="vendedor_atual_id" :rules="{ required: true, message: 'Selecione o Vendedor atual', trigger: 'change' }">
                <br />
                <el-select 
                  v-model="mudar_vendedor_orcamento.vendedor_atual_id" 
                  filterable 
                  placeholder="Selecione um vendedor atual" 
                  clearable 
                  class="select-data-2"
                >
                  <el-option v-for="vendedor in vendedores" :key="vendedor.id" :label="vendedor.nome" :value="vendedor.id" />
                </el-select>
              </el-form-item>


              <el-form-item label="Vendedor Novo" prop="vendedor_novo_id" :rules="{ required: true, message: 'Selecione um Vendedor novo', trigger: 'change' }">
                <br />
                <el-select 
                  v-model="mudar_vendedor_orcamento.vendedor_novo_id" 
                  filterable 
                  placeholder="Selecione o vendedor novo" 
                  clearable 
                  class="select-data-2"
                >
                  <el-option v-for="vendedor in vendedores" :key="vendedor.id" :label="vendedor.nome" :value="vendedor.id" />
                </el-select>
              </el-form-item>


              <el-button type="primary" native-type="submit">Alterar Vendedor dos Orçamentos</el-button>
            </el-form>

          </div>
        </el-card>
      </el-col>

    </el-row>



  </div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: true,
      mudar_vendedor_cliente: {
        vendedor_atual_id: null,
        vendedor_novo_id: null,
      },
      mudar_vendedor_orcamento: {
        vendedor_atual_id: null,
        vendedor_novo_id: null,
      },
      vendedores: [],
      permissao: {},
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.manutencao_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.getVendedores()
  },
  methods: {
    async getVendedores() {
      this.loading = true;
      try {
        const response = await axios.get(`${url}/vendedores-recursivo`, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.vendedores = response.data;
          // console.log("Vendedores:", this.vendedores);
        }
      } catch (err) {
        console.error("Erro ao buscar vendedores:", err);
      } finally {
        this.loading = false;
      }
    },
    async mudarVendedorCliente() {
      const vendedor_atual_id = this.mudar_vendedor_cliente.vendedor_atual_id;
      const vendedor_novo_id = this.mudar_vendedor_cliente.vendedor_novo_id;
      if (!vendedor_atual_id || !vendedor_novo_id) {
        this.$message.error("Por favor, preencha todos os campos.");
        return;
      }
      if (vendedor_atual_id == vendedor_novo_id) {
        this.$message.error("Por favor, selecione vendedores diferentes.");
        return;
      }
      this.$confirm('Tem certeza que deseja alterar de vendedor nos clientes?', 'Pergunta', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        try {
          const response = await axios.put(`${url}/termometria-clientes-vendedor-alterar/${vendedor_atual_id}/${vendedor_novo_id}`, 
          {},
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          });
          if (response.data.status === "Token is Expired") {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
          } else {
            this.$message.success("Alterado para o novo Vendedor nos Clientes!");
            this.getVendedores();
          }
        } catch (err) {
          console.error("Erro ao alterar Vendedores:", err);
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        this.$message.error("Processo de alteração do Vendedor abortado.");
      });
    },
    async mudarVendedorOrcamento() {
      const vendedor_atual_id = this.mudar_vendedor_orcamento.vendedor_atual_id;
      const vendedor_novo_id = this.mudar_vendedor_orcamento.vendedor_novo_id;
      if (!vendedor_atual_id || !vendedor_novo_id) {
        this.$message.error("Por favor, preencha todos os campos.");
        return;
      }
      if (vendedor_atual_id == vendedor_novo_id) {
        this.$message.error("Por favor, selecione vendedores diferentes.");
        return;
      }
      this.$confirm('Tem certeza que deseja alterar de vendedor nos orçamentos?', 'Pergunta', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        try {
          const response = await axios.put(`${url}/termometria-orcamento-vendedor-alterar/${vendedor_atual_id}/${vendedor_novo_id}`, 
          {},
          {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          });
          if (response.data.status === "Token is Expired") {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
          } else {
            this.$message.success("Alterado para o novo Vendedor nos Orçamentos!");
            this.getVendedores();
          }
        } catch (err) {
          console.error("Erro ao alterar Vendedores:", err);
        } finally {
          this.loading = false;
        }
      }).catch(() => {
        this.$message.error("Processo de alteração do Vendedor abortado.");
      });
    },

  },

};
</script>

<style>
  .el-row-topo {
    margin-top: 10px;
  }

  .text-2 {
    text-align: left;
  }

  .item-2 {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
  }

  .select-data-2 {
    width: 100%;
  }
</style>
